var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormatBoldOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6V13H12.8246C15.2982 13 17.3333 11 17.3333 8.49123C17.3333 6 15.2982 4 12.8246 4H8C6.87719 4 6 4.87719 6 6ZM8 6H12.8246C14.3509 6 15.3333 6.98246 15.3333 8.49123C15.3333 10.0175 14.3509 11 12.8246 11H8V6ZM6 18C6 19.1228 6.87719 20 8 20H13.5088C16 20 18 18 18 15.4912C18 13 16 11 13.5088 11H6V18ZM8 18V13H13.5088C15.0175 13 16 13.9825 16 15.4912C16 17.0175 15.0175 18 13.5088 18H8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatBoldOutlined);
export default __webpack_public_path__ + "static/media/format_bold_outlined.016d70d6.svg";
export { ForwardRef as ReactComponent };